import { render, staticRenderFns } from "./finesgoodsPage.vue?vue&type=template&id=6e4c3574&scoped=true&"
import script from "./finesgoodsPage.vue?vue&type=script&lang=js&"
export * from "./finesgoodsPage.vue?vue&type=script&lang=js&"
import style0 from "./finesgoodsPage.vue?vue&type=style&index=0&id=6e4c3574&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4c3574",
  null
  
)

export default component.exports